import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, TripCustomerfetchData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { ThreeDRotationOutlined } from '@mui/icons-material';
import { Discount } from '@mui/icons-material';
import { FaWeight } from 'react-icons/fa';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Make sure axios is installed and imported
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import InvoicePrint from './Estimate';
import NongstBillPrint from './Bill';


const truncate2 = (num) => Math.trunc(num * 100) / 100;

const CounterSaleCreate = () => {
    const { id, tid } = useParams();

    const history = useHistory();
    const { isAuthenticated, companyId, userId, customerid, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [data, setData] = useState(null);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState(''); // Correct 
    const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
    const [GSTRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");
    const [SaleRemarks, setSaleRemarks] = useState("");
    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [Bundle, setBundle] = useState('');
    const [Pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");

    const [OrderDate, setOrderDate] = useState('');
    const [Route, setRoute] = useState("");
    const [routeId, setrouteId] = useState("");

    useEffect(() => {
        fetchtableData();
        fetchItemsTypes();
    }, []);

    const fetchtableData = async () => {
        try {
            const response = await fetchData('RoutePriceTypeApi', `/${id}`, token);

            if (response.responseCode === '1111') {
                setData(response.response_data);

                const Route = response.response_data[0].name;
                const pricetype = response.response_data[0].pricetype;
                const routeId = response.response_data[0].id; // Retrieve routeId
                const orderDate = response.response_data[0].orderDate;

                setpricetype(pricetype);
                setRoute(Route);
                setOrderDate(orderDate);
                setrouteId(routeId);
                console.log(response);

            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [pricetype, setpricetype] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [customerpricetype, setcustomerpricetype] = useState('');

    const [CustId, setcustId] = useState('');
    // Function to fetch routes
    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching routes:', error);
        }
    };

    const handleRouteWiseCustomerChange = async (selectedOption) => {
        if (!selectedOption) return; // Guard clause for null/undefined selectedOption

        setSelectedRoute(selectedOption);
        setSelectedCustomer(null); // Reset customer selection
        setCustomerOptions([]); // Clear previous customer options

        try {
            // Start loading
            setLoading(true);

            // Fetch customers based on the selected route
            const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111' && Array.isArray(response.response_data)) {
                // Set the state for pricetype and paymentType
                setcustomerpricetype(response.response_data[0]?.customerpricetype || '');
                setPaymentType(response.response_data[0]?.paymentType || '');

                const customerOptions = response.response_data.map((customer) => ({
                    value: customer.id,
                    label: customer.name + customer.addressLine1,
                }));
                setCustomerOptions(customerOptions);
            } else {
                console.error('Unexpected response format:', response);
                // Display a fallback or default message to the user
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
            // Optionally, show an error message to the user
        } finally {
            // End loading
            setLoading(false);
        }
    };

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const CustId = selectedOption.value;
        setcustId(CustId);
    };

    useEffect(() => {
        fetchRouteTypes();
    }, []);

    //Product catgory
    useEffect(() => {
        const fetchPCategoryTypes = async () => {
            try {
                const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(pcat => ({
                        value: pcat.id,
                        label: pcat.name
                    }));
                    setPCategoryOptions(options);
                    setPCategoryId(dataArray[0].id);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchPCategoryTypes();
    }, [companyId, token]);


    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // Formats date as 'YYYY-MM-DD'
    };

    const [formData, setFormData] = useState({
        BillDate: getCurrentDate(),
        BalanceAmount: "0.00",
    });

    // Ensure BillDate initializes only on mount
    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            BillDate: getCurrentDate(),
        }));
    }, []);


    const handlePCategoryChange = (selectedOption) => {
        setSelectedPCategory(selectedOption);
        fetchCategoryTypes(selectedOption.value);
        // fetchItemsTypes(selectedOption.value);
        setPCategoryId(selectedOption.value);
        setSelectedItem(null);
    };


    //catgory
    const fetchCategoryTypes = async (productCategoryId) => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
                //setCategoryId(dataArray[0].id);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        fetchItemsTypes(selectedOption.value);
        setCategoryId(selectedOption.value);
        setSelectedItem(null);
    };
    const calculateGrandTotal = () => {
        return itemList.reduce((acc, item) => acc + item.totalPlusGst, 0).toFixed(2);
    };
    
    const handleChange = (event) => {
        const { name, value } = event.target;
        let updatedValue = value === "" ? "0" : value; // Ensure empty input is treated as 0
    
        // Convert values to numbers safely
        const cash = name === "CashAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.CashAmount) || 0;
        const card = name === "CardAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.CardAmount) || 0;
        const upi = name === "UPIAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.UPIAmount) || 0;
    
        const grandTotal = parseFloat(calculateGrandTotal()); // Get latest Grand Total
    
        // Ensure the total does not exceed Grand Total
        let totalEntered = cash + card + upi;
        if (totalEntered > grandTotal) {
            updatedValue = Math.max(0, grandTotal - (totalEntered - updatedValue));
        }
    
        // Calculate remaining balance
        const balance = grandTotal - totalEntered;
    
        // Update form state
        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
            BalanceAmount: balance < 0 ? "0.00" : balance.toFixed(2), // Prevent negative balance
        }));
    };
    

    // const handleChange = (event) => {
    //     const { name, value } = event.target;
    //     let updatedValue = value === "" ? "0" : value;  // Ensure empty input is treated as 0

    //     // Convert values to numbers safely
    //     const cash = name === "CashAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.CashAmount) || 0;
    //     const card = name === "CardAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.CardAmount) || 0;
    //     const upi = name === "UPIAmount" ? parseFloat(updatedValue) || 0 : parseFloat(formData.UPIAmount) || 0;

    //     const grandTotal = calculateGrandTotal();  // Get the latest Grand Total

    //     // Ensure the total does not exceed Grand Total
    //     let totalEntered =
    //         (updatedFormData.CashAmount || 0) +
    //         (updatedFormData.CardAmount || 0) +
    //         (updatedFormData.UPIAmount || 0);

    //     if (totalEntered > calculateGrandTotal()) {
    //         newValue = Math.max(0, calculateGrandTotal() - (totalEntered - newValue));
    //         updatedFormData[name] = newValue;
    //     }
    //     // Function to calculate Grand Total
    //     const calculateGrandTotal = () => {
    //         return itemList.reduce((acc, item) => acc + item.totalPlusGst, 0).toFixed(2);
    //     };

    //     // Calculate balance
    //     const balance = grandTotal - totalEntered;

    //     // Update form state
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: updatedValue,

    //         BalanceAmount: balance < 0 ? "0.00" : balance.toFixed(2),  // Ensure balance is not negative
    //     }));
    // };


    const fetchItemsTypes = async () => {
        try {
            // const response = await fetchData('CounterSaleApi', `/${companyId}`, token);
            const response = await fetchData('CounterSaleApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const [QtyBundle, setQtyBundle] = useState('');
    const [ProductCategoryId, setProductCategoryId] = useState('');
    const [CategoryId, setCategorysId] = useState('');


    const handleItemChange = async (selectedOptions) => {
        setSelectedItem(selectedOptions);
        const ItemID = selectedOptions.value;
        setItemId(ItemID);

        try {
            const response = await fetchData('ItemRateCheckingApi', `/${CustId}/${ItemID}`, token);

            if (response && response.response_data && response.response_data.length > 0) {
                let itemFound = false;

                // Iterate through each category in response_data
                response.response_data.forEach(category => {
                    if (category.Items && category.Items.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                console.log(`Processing item: ${item.Name}`);
                                // Process each item here
                                // Extract numeric part from Weight

                                const { Rate, GSTRate, Weight, Bundle, QtyBundle, ProductCategoryId, CategoryId } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(Bundle);
                                setQtyBundle(QtyBundle);
                                setProductCategoryId(ProductCategoryId);
                                setCategorysId(CategoryId);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight, // Add weight to the newItem state
                                    rate: Rate,
                                    GSTRate: GSTRate,
                                    //Bundle: Bundle,
                                    ProductCategoryId: ProductCategoryId,
                                    CategoryId: CategoryId,
                                    Bundle: Bundle ?? 0, // Set Bundle to 0 if it's null
                                    QtyBundle: QtyBundle ?? 0,
                                }));
                                itemFound = true; // Set itemFound to true when an item is processed
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };


    const [newItem, setNewItem] = useState("");

    const handleQtyChange = (e) => {
        const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
        if (input.length <= 10) { // Limit input length to avoid overflow
            setQty(input); // Update state with cleaned input

            const quantity = parseInt(input) || 0; // Parse input to integer, default to 0 if NaN
            // Calculate other derived values based on your logic
            const gstAmount = (rate * GSTRate) / 100;
            const totalAmount = rate * quantity;
            const totalPlusGst = totalAmount + gstAmount;
            const totalQuantity = newItem.weight * quantity;

            // Update state with the new calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                quantity: quantity,
                totalAmount: totalAmount,
                GSTRate: GSTRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,

                discount: discount,
                totalQuantity: totalQuantity,
            }));
        }
    };



    useEffect(() => {
        const quantity = parseInt(qty) || 0;
        const gstAmount = (rate * GSTRate) / 100;
        const totalAmount = rate * quantity;
        const totalPlusGst = totalAmount + gstAmount;
        const bundle = Bundle;
        //const pieceCount = quantity % newItem.Bundle;
        setNewItem((prevItem) => ({
            ...prevItem,
            rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            Bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);

    const defaultItem = {
        Id: '',
        Name: '',
        quantity: 1,
        GSTRate: 0,
        rate: 0,
        totalAmount: 0,
        totalPlusGst: 0,
        discount: 0,
        weight: 0,
        totalQuantity: 0,
        rateperkg: 0,
        TotalAmtperkgwise: 0,
        GstPer: 0,
        gstAmount: 0,
        TaxableAmount: 0,
        Bundle: 0,
        Pieces: 0,
        singlediscount: 0,
    };

    const AddtoListdata = (e) => {
        e.preventDefault();
        if (qty > 0) {
            const quantity = parseInt(qty);
            //const bundleSize = parseInt(newItem.Bundle);
            const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0

            // Calculate number of bundles and remaining pieces
            // Check if bundleSize is valid (not null or 0)
            const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? quantity % bundleSize : 0;

            const rateperkg = rate;
            const totalQuantity = newItem.weight * quantity;
            const totalAmount = rate * quantity;
            const TotalAmtperkgwise = rateperkg * totalQuantity;
            const TaxableAmount = truncate2(((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate));
            const gstAmount = truncate2((TaxableAmount * GSTRate) / 100);
            const GstPer = (gstAmount / TaxableAmount) * 100;
            const totalPlusGst = Math.round(TaxableAmount + gstAmount);

            const updatedItem = {
                ...newItem,
                Name: selectedItem.label,
                Id: selectedItem.value,
                quantity: quantity,
                rate: rate,
                GSTRate: GSTRate,
                totalAmount: totalAmount,
                totalPlusGst: totalPlusGst,
                discount: discount,
                totalQuantity: totalQuantity,
                rateperkg: rateperkg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                TaxableAmount: TaxableAmount,
                gstAmount: gstAmount,
                GstPer: GstPer,
                Bundle: numBundles,
                Pieces: pieceCount,
                QtyBundle: QtyBundle,
            };

            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                Id: '',
                Name: '',
                quantity: 1,
                GSTRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                totalQuantity: 0,
                rateperkg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                gstAmount: 0,
                TaxableAmount: 0,
                Bundle: 0,
                pieces: 0,
            });

            // Resetting other state variables
            setNewItem({ ...defaultItem });
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };

    const handleDiscountChange = (e, index) => {
        const value = parseFloat(e.target.value) || 0; // Parse discount value
        const updatedItems = [...itemList];
        const item = updatedItems[index];

        item.singlediscount = value;

        const totalQuantity = item.totalQuantity || 0; // Ensure quantity has a default value
        const rateperkg = item.rateperkg || 0; // Base rate per kg

        // Calculate the new discounted rate
        const discountedRatePerKg = rateperkg - value;

        // Calculate the taxable amount based on the discounted rate
        const TaxableAmount = truncate2((discountedRatePerKg * totalQuantity * 100) / (100 + item.GSTRate) || 0);

        // Calculate GST and total with GST
        const gstAmount = truncate2((TaxableAmount * item.GSTRate) / 100 || 0);
        const totalPlusGst = Math.round(TaxableAmount + gstAmount);

        // Update the item with calculated values
        item.totalPlusGst = totalPlusGst;
        item.discount = value;
        item.gstAmount = parseFloat(gstAmount);
        item.GstPer = item.GSTRate; // GST% remains as the item's defined rate
        item.TaxableAmount = parseFloat(TaxableAmount);

        // Update the item list state
        setItemList(updatedItems);
    };

    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        const quantity = parseInt(value, 10);
        updatedItems[index].quantity = quantity;

        let bundleSize = 0;
        const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
        const bag = updatedItems[index].BagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;

        if (bag > 0) {
            BagWeight = bag;
            bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
        } else if (bagweight > 0) {
            BagWeight = bagweight;
            bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
        }

        const rateperkg = updatedItems[index].rateperkg || 0;

        const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
        const pieceCount = bundleSize ? quantity % bundleSize : 0;
        // Calculate Total Quantity (Kgs)
        const TotalQuantity = BagWeight * quantity;
        updatedItems[index].totalQuantity = TotalQuantity;

        const RateAfterDiscount = rateperkg - DiscountPerPiece;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;

        const TaxableAmount = truncate2(((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0);
        updatedItems[index].TaxableAmount = TaxableAmount;

        const gstAmount = truncate2((TaxableAmount * updatedItems[index].GSTRate / 100) || 0);
        updatedItems[index].gstAmount = gstAmount;

        const totalPlusGst = Math.round(TaxableAmount + gstAmount);
        updatedItems[index].totalPlusGst = totalPlusGst;

        const totalAmount = RateAfterDiscount * quantity;
        updatedItems[index].totalAmount = totalAmount;

        updatedItems[index].Bundle = numBundles;
        updatedItems[index].Pieces = pieceCount;

        console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values

        setItemList(updatedItems); // This should trigger a re-render with the updated state
    };

    const totalItemMaster = () => {
        const totalQuantity = itemList.reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);
        const totalAmount = itemList.reduce((sum, item) => sum + (parseFloat(item.totalPlusGst) || 0), 0);
        const totalTaxableAmount = itemList.reduce((sum, item) => sum + (parseFloat(item.TaxableAmount) || 0), 0);
        const totalCgstAmount = itemList.reduce((sum, item) => sum + (parseFloat(item.gstAmount / 2) || 0), 0);
        const totalSgstAmount = itemList.reduce((sum, item) => sum + (parseFloat(item.gstAmount / 2) || 0), 0);
        const totalPlusGst = itemList.reduce((sum, item) => sum + (parseFloat(item.totalPlusGst) || 0), 0);
        const totalWeight = itemList.reduce((sum, item) => sum + (parseFloat(item.totalQuantity) || 0), 0);
        const DiscountPer = itemList.reduce((sum, item) => sum + (parseFloat(item.singlediscount) || 0), 0);

        return {
            totalQuantity: parseFloat(totalQuantity.toFixed(2)),
            totalAmount: parseFloat(totalAmount.toFixed(2)),
            TaxableAmount: parseFloat(totalTaxableAmount.toFixed(2)),
            totalCgstAmount: parseFloat(totalCgstAmount.toFixed(2)),
            totalSgstAmount: parseFloat(totalSgstAmount.toFixed(2)),
            totalPlusGst: parseFloat(totalPlusGst.toFixed(2)),
            totalWeight: parseFloat(totalWeight.toFixed(2)),
            DiscountPer: parseFloat(DiscountPer.toFixed(2)),
        };
    };

    // Example usage:
    const totals = totalItemMaster();
    console.log(totals);

    let TotAmount = totals.totalAmount || 0; // Ensure a default value

    // Correct Round-Off Calculation
    const roundedTotal = Math.round(TotAmount);  // Round to nearest integer
    const AmountRoff = parseFloat((roundedTotal - TotAmount).toFixed(2)); // Get difference, rounded to 2 decimals

    // Ensure TotAmount is updated correctly
    TotAmount = roundedTotal;


    const submitData = async (e) => {
        e.preventDefault();
        try {
            const itemsToSave = itemList.map(item => ({
                CompanyId: companyId,
                CustomerId: CustId,
                ItemId: item.Id,
                ProductCateogryId: item.ProductCategoryId,
                CategoryId: item.CategoryId,
                Bundle: item.Bundle,
                Pieces: item.Pieces,
                Rate: item.rate,
                Quantity: item.quantity,
                Amount: item.TaxableAmount.toFixed(2),
                GSTRate: item.GSTRate,
                CGSTAmount: (item.gstAmount / 2).toFixed(2),
                SGSTAmount: (item.gstAmount / 2).toFixed(2),
                IGSTAmount: 0,
                TotalAmount: Math.round(item.totalPlusGst.toFixed(2)),
                NetAmount: item.totalPlusGst.toFixed(2),
                TaxableAmt: item.TaxableAmount.toFixed(2),
                RatePerKg: item.rateperkg,
                DiscountPerPiece: item.singlediscount || 0,
                RateAfterDiscount: (item.rateperkg - (item.singlediscount || 0)) || 0,
                TotalQty: item.totalQuantity,
                BagWeight: item.weight,
                CreatedBy: userId,
                CreatedDate: new Date(),
            }));

            const countersaledata = {
                CustomerId: CustId,
                RouteId: selectedRoute.value,
                CompanyId: companyId,
                InvoiceDate: new Date(),
                Bundle: totals.totalQuantity,
                Pieces: totals.totalWeight,
                TotalAmount: parseFloat(Math.round(totals.totalAmount).toFixed(2)),

                NetAmount: parseFloat(totals.totalAmount).toFixed(2),
                CGSTAmount: totals.totalCgstAmount,
                SGSTAmount: totals.totalSgstAmount,
                GrandTotal: totals.totalPlusGst,
                TotalQty: totals.totalQuantity,
                RoundOff: AmountRoff,
                CashAmount: formData.CashAmount || 0,
                CardAmount: formData.CardAmount || 0,
                UPIAmount: formData.UPIAmount || 0,
                NetAmount: totals.totalAmount || 0,
                PaidAmount:
                    (parseFloat(formData.CashAmount) || 0) +
                    (parseFloat(formData.CardAmount) || 0) +
                    (parseFloat(formData.UPIAmount) || 0),
                BalanceAmount: formData.BalanceAmount || 0,
                TaxableAmount: totals.TaxableAmount || 0,
                DiscountPer: totals.DiscountPer,
                CreatedBy: userId,
                CreatedDate: new Date(),
                TaxMethod: 1,
                BillPrefix: "BB",
                IsGST: true
            };

            const CounterSaleVM = {
                CounterSale: countersaledata,
                CounterSaleDetails: itemsToSave,
            };

            // Show a confirmation dialog before submitting the order
            const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
            if (confirmOrder) {
                const response = await postData('CounterSaleApi', CounterSaleVM, token);

                if (response && response.saleOrderId) {
                    const CounterSaleid = response.saleOrderId;
                    await handleSaleOrderPrint(CounterSaleid); // Wait for print to complete
                }

                history.push('/CounterSaleIndex');
            }
        } catch (error) {
            console.error('Submit error:', error);
        }
    };

    const submitData2 = async (e) => {
        e.preventDefault();
        try {
            const itemsToSave = itemList.map(item => ({
                CompanyId: companyId,
                CustomerId: CustId,
                ItemId: item.Id,
                ProductCateogryId: item.ProductCategoryId,
                CategoryId: item.CategoryId,
                Bundle: item.Bundle,
                Pieces: item.Pieces,
                Rate: item.rate,
                Quantity: item.quantity,
                Amount: item.TaxableAmount.toFixed(2),
                GSTRate: item.GSTRate,
                CGSTAmount: (item.gstAmount / 2).toFixed(2),
                SGSTAmount: (item.gstAmount / 2).toFixed(2),
                IGSTAmount: 0,
                TotalAmount: Math.round(item.totalPlusGst.toFixed(2)),
                NetAmount: item.totalPlusGst.toFixed(2),
                TaxableAmt: item.TaxableAmount.toFixed(2),
                RatePerKg: item.rateperkg,
                DiscountPerPiece: item.singlediscount || 0,
                RateAfterDiscount: (item.rateperkg - (item.singlediscount || 0)) || 0,
                TotalQty: item.totalQuantity,
                BagWeight: item.weight,
                CreatedBy: userId,
                CreatedDate: new Date(),
            }));

            const countersaledata = {
                CustomerId: CustId,
                RouteId: selectedRoute.value,
                CompanyId: companyId,
                InvoiceDate: new Date(),
                Bundle: totals.totalQuantity,
                Pieces: totals.totalWeight,
                TotalAmount: parseFloat(Math.round(totals.totalAmount).toFixed(2)),

                NetAmount: parseFloat(totals.totalAmount).toFixed(2),
                CGSTAmount: totals.totalCgstAmount,
                SGSTAmount: totals.totalSgstAmount,
                GrandTotal: totals.totalPlusGst,
                TotalQty: totals.totalQuantity,
                RoundOff: AmountRoff,
                CashAmount: formData.CashAmount || 0,
                CardAmount: formData.CardAmount || 0,
                UPIAmount: formData.UPIAmount || 0,
                NetAmount: totals.totalAmount || 0,
                PaidAmount:
                    (parseFloat(formData.CashAmount) || 0) +
                    (parseFloat(formData.CardAmount) || 0) +
                    (parseFloat(formData.UPIAmount) || 0),
                BalanceAmount: formData.BalanceAmount || 0,
                TaxableAmount: totals.TaxableAmount || 0,
                DiscountPer: totals.DiscountPer,
                CreatedBy: userId,
                CreatedDate: new Date(),
                TaxMethod: 2,
                BillPrefix: "C",
                IsGST: true
            };

            const CounterSaleVM = {
                CounterSale: countersaledata,
                CounterSaleDetails: itemsToSave,
            };

            // Show a confirmation dialog before submitting the order
            const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
            if (confirmOrder) {
                const response = await postData('CounterSaleApi', CounterSaleVM, token);

                if (response && response.saleOrderId) {
                    const CounterSaleid = response.saleOrderId;
                    await handleSaleOrderPrint(CounterSaleid); // Wait for print to complete
                }

                history.push('/CounterSaleIndex');
            }
        } catch (error) {
            console.error('Submit error:', error);
        }
    };
    const submitData3 = async (e) => {
        e.preventDefault();
        try {
            const itemsToSave = itemList.map(item => ({
                CompanyId: companyId,
                CustomerId: CustId,
                ItemId: item.Id,
                ProductCateogryId: item.ProductCategoryId,
                CategoryId: item.CategoryId,
                Bundle: item.Bundle,
                Pieces: item.Pieces,
                Rate: item.rate,
                Quantity: item.quantity,
                Amount: item.TaxableAmount.toFixed(2),
                GSTRate: item.GSTRate,
                CGSTAmount: (item.gstAmount / 2).toFixed(2),
                SGSTAmount: (item.gstAmount / 2).toFixed(2),
                IGSTAmount: 0,
                TotalAmount: item.totalPlusGst.toFixed(2),
                NetAmount: item.totalPlusGst.toFixed(2),
                TaxableAmt: item.TaxableAmount.toFixed(2),
                RatePerKg: item.rateperkg,
                DiscountPerPiece: item.singlediscount || 0,
                RateAfterDiscount: (item.rateperkg - (item.singlediscount || 0)) || 0,
                TotalQty: item.totalQuantity,
                BagWeight: item.weight,
                CreatedBy: userId,
                CreatedDate: new Date(),
            }));

            const countersaledata = {
                CustomerId: CustId,
                RouteId: selectedRoute.value,
                CompanyId: companyId,
                InvoiceDate: new Date(),
                Bundle: totals.totalQuantity,
                Pieces: totals.totalWeight,
                TotalAmount: parseFloat(Math.round(totals.totalAmount).toFixed(2)),

                NetAmount: parseFloat(totals.totalAmount).toFixed(2),
                CGSTAmount: totals.totalCgstAmount,
                SGSTAmount: totals.totalSgstAmount,
                GrandTotal: totals.totalPlusGst,
                TotalQty: totals.totalQuantity,
                RoundOff: AmountRoff,
                CashAmount: formData.CashAmount || 0,
                CardAmount: formData.CardAmount || 0,
                UPIAmount: formData.UPIAmount || 0,
                NetAmount: totals.totalAmount || 0,
                PaidAmount:
                    (parseFloat(formData.CashAmount) || 0) +
                    (parseFloat(formData.CardAmount) || 0) +
                    (parseFloat(formData.UPIAmount) || 0),
                BalanceAmount: formData.BalanceAmount || 0,
                TaxableAmount: totals.TaxableAmount || 0,
                DiscountPer: totals.DiscountPer,
                CreatedBy: userId,
                CreatedDate: new Date(),
                TaxMethod: 3,
                BillPrefix: "E",
                IsGST: false
            };


            const CounterSaleVM = {
                CounterSale: countersaledata,
                CounterSaleDetails: itemsToSave,
            };

            // Show a confirmation dialog before submitting the order
            const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
            if (confirmOrder) {
                const response = await postData('CounterSaleApi', CounterSaleVM, token);

                if (response && response.saleOrderId) {
                    const CounterSaleid = response.saleOrderId;
                    await handleSaleOrderPrint(CounterSaleid); // Wait for print to complete
                }

                history.push('/CounterSaleIndex');
            }
        } catch (error) {
            console.error('Submit error:', error);
        }
    };
    const handleSaleOrderPrint = async (CounterSaleid) => {
        try {
            // Fetch data
            const response = await fetchData('CounterSaleApi', `/CounterSalePrint/${CounterSaleid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                labelData[0].CounterSalePrint.IsGST === true ? (
                    <InvoicePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ) : (
                    <NongstBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ),
                iframeDocument.body
            );


            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('CounterSaleApi', `${CounterSaleid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }


    };


    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);

    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };


    return (

        <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ maxWidth: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '2000px', overflowY: 'auto' }}>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '-10px',
                    }}
                >
                    Counter Sale
                </h6>
                <form onSubmit={submitData}>

                    <div className="flex mb-2" style={{ justifyContent: "flex-end", marginTop: '-10PX' }}>
                        <Button onClick={submitData} style={{ backgroundColor: '#FFA09B', height: '30px', fontWeight: 'bolder', color: 'white' }} >
                            GST
                        </Button>
                        &nbsp;&nbsp;
                        <Button onClick={submitData2} style={{ backgroundColor: '#C8AAAA', height: '30px', fontWeight: 'bolder', color: 'white' }} >
                            Tax
                        </Button>
                        &nbsp;&nbsp;
                        <Button onClick={submitData3} style={{ backgroundColor: '#86A788', height: '30px', fontWeight: 'bolder', color: 'white' }} >
                            Estimate
                        </Button>

                        <Tooltip title="Exit">
                            <Link to={`/CounterSaleIndex`}>
                                <Button variant="contained" color="error" style={{ marginLeft: '10px', height: '30px', backgroundColor: '#C890A7' }}>
                                    Back<ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="route">
                                Route
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedRoute}
                                onChange={handleRouteWiseCustomerChange}
                                options={routeOptions}
                                placeholder="Select Route"
                                isSearchable
                            />
                        </div>


                        <div className="w-full sm:w-1/3 pl-2  sm:block">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>

                            <Select
                                options={customerOptions}
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                placeholder="Select a Customer"
                                isSearchable
                            />
                        </div>


                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Sale Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.BillDate}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'
                                style={{ marginLeft: '10px' }}
                                readOnly
                            />
                        </div>


                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-0.50%' }}>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" >
                                Variant with Bagweight
                            </label>
                            <Select
                                value={selectedItem}
                                onChange={handleItemChange}
                                options={itemOptions}
                                placeholder="Select Item"
                                isSearchable

                            />
                        </div>
                        <div className="w-1/8 mr-2" >
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Quantity">
                                QTY (No.of pieces)

                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:shadow-outline font-bold"
                                value={qty}
                                onChange={handleQtyChange}
                                type="text"
                                placeholder="Quantity"
                                style={{ width: '150px', height: '37px' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <Button variant="contained" color="primary" onClick={AddtoListdata} style={{ marginTop: '32px', marginLeft: '10px', fontSize: '12px' }}>Add Item</Button>
                        </div>

                    </div>

                    <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                        <div className="w-full mb-2" style={{ backgroundColor: '#c9dedb', marginTop: '-0.15%', overflow: 'auto' }}>
                            <table
                                className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                                style={{ borderCollapse: 'collapse' }}
                            >
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>NAME</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>QTY</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>T.QTY</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>BUNDLE</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>PIECES</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>RATE (k/g)</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS ₹</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>RATE AFTER DISC</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TAXABLE</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GST %</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GST ₹</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TOTAL</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {itemList.map((item, index) => {
                                        return (
                                            <tr key={index} className="border-b"
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                    borderBottom: '1px solid #E0E0E0',
                                                    transition: 'transform 0.2s ease-in-out',
                                                    cursor: 'pointer',
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            >
                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '65px' }}>
                                                    {index + 1}
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <DeleteIcon
                                                                style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                                onClick={() => openConfirmDialog(index)}
                                                            />
                                                        </Tooltip>
                                                    </td>
                                                </td>
                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '250px' }}>{item.Name}</td>

                                                <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.quantity}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`Order quantity for item ${item.Id}`}
                                                        name="quantity"
                                                        onChange={(e) => handleQuantityChange(e, index)}
                                                    />
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.totalQuantity}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.Bundle}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.Pieces}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{item.rateperkg}</td>


                                                <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={(isNaN(item.singlediscount) || item.singlediscount === "") ? "0" : item.singlediscount}
                                                        onChange={(e) => handleDiscountChange(e, index)}
                                                        className="w-full px-2 py-1 border rounded text-sm"
                                                        step="0.01"
                                                        min="0"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    />
                                                </td>

                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: "8px", fontSize: "14px", width: "12%" }}>
                                                    {((item.singlediscount ?? 0) === 0
                                                        ? item.rateperkg
                                                        : (item.rateperkg - item.singlediscount)
                                                    ).toFixed(2)}
                                                </td>


                                                <td className="px-4 py-2 border-r text-right text-sm">
                                                    {isNaN(item.TaxableAmount) || item.TaxableAmount === ""
                                                        ? "0.00"
                                                        : item.TaxableAmount.toFixed(2)}
                                                </td>

                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.GSTRate}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{item.gstAmount.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{(item.totalPlusGst).toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>

                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={() => handleDelete(itemToDeleteIndex)}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>

                                </Dialog>
                            </table>

                            <table
                                className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                                style={{ borderCollapse: 'collapse' }}
                            >
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GRAND TOTAL</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>ROUNDED GRANDTOTAL</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>CASH AMOUNT</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>CARD AMOUNT</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>UPI AMOUNT</th>
                                        <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>BALANCE AMOUNT</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="border-b"
                                        style={{
                                            backgroundColor: '#F7FAFF',
                                            borderBottom: '1px solid #E0E0E0',
                                            transition: 'transform 0.2s ease-in-out',
                                            cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    >

                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            {calculateGrandTotal()}
                                        </td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            {Math.round(calculateGrandTotal())}
                                        </td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            <input
                                                type="number"
                                                name="CashAmount"
                                                value={formData.CashAmount || '0'}
                                                onChange={handleChange}
                                                onClick={(e) => e.target.select()}
                                                className="w-full px-2 py-1 border rounded text-sm"
                                                step="0.01"
                                                min="0"
                                                max={calculateGrandTotal()}  // Prevents entry above Grand Total
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            <input
                                                type="number"
                                                name="CardAmount"
                                                value={formData.CardAmount || '0'}
                                                onChange={handleChange}
                                                onClick={(e) => e.target.select()}
                                                className="w-full px-2 py-1 border rounded text-sm"
                                                step="0.01"
                                                min="0"
                                                max={Math.max(
                                                    0,
                                                    calculateGrandTotal() - (parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0))
                                                )}
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </td>


                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            <input
                                                type="number"
                                                name="UPIAmount"
                                                value={formData.UPIAmount || '0'}
                                                onClick={(e) => e.target.select()}
                                                onChange={handleChange}
                                                className="w-full px-2 py-1 border rounded text-sm"
                                                step="0.01"
                                                min="0"
                                                max={Math.max(
                                                    0,
                                                    calculateGrandTotal() - (parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0))
                                                )}
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </td>


                                        <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                            {formData.BalanceAmount}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>




                        </div>
                    </div>


                    {/* </div> */}
                </form >
            </div >
        </div >
    );
};

export default CounterSaleCreate;
